var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('GradientLegend',{attrs:{"title":_vm.$t('message.modelOutput'),"colors":_vm.data.colors,"gradientCss":_vm.data.gradient,"ticks":_vm.data.ticks}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }